import { render, staticRenderFns } from "./BoardEditUI.vue?vue&type=template&id=207fb95e&scoped=true&"
import script from "./BoardEditUI.vue?vue&type=script&lang=js&"
export * from "./BoardEditUI.vue?vue&type=script&lang=js&"
import style0 from "./BoardEditUI.vue?vue&type=style&index=0&id=207fb95e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.8_cache-loader@4.1.0_webpack@4.46.0__css-loader@3.6.0_webpack@4.46.0__lodash@_un4jhf4odrklsfexjnq27ps2iu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207fb95e",
  null
  
)

export default component.exports